@if (card) {
  <div
    class="container"
    [class.small]="small">
    <div
      class="top"
      [ngStyle]="{
        'background-image': 'url(' + card?.backgroundUrl + ')',
        width: modifiedWidth ? 'calc(100% - 28px)' : '100%'
      }">
      @if (!contentEdit) {
        <h4 [innerHTML]="card.headline"></h4>
      }
      @if (contentEdit) {
        <h4
          #heading
          [contentEditable]="contentEdit"
          [textContent]="card?.headline"
          (input)="card.headline = heading.textContent"></h4>
      }
      @if (card?.icon) {
        <div class="icon-wrapper">
          <div
            class="icon"
            [ngStyle]="{ 'background-image': 'url(' + iconUrl + ')' }"></div>
        </div>
      }
      @if (contentEdit) {
        <coin-v2-button
          type="secondary"
          class="cms-card-change-picture"
          svgIcon="edit"
          [text]="'cms.content-pages.change-image-button' | translate"
          (click)="editPicture(card)"></coin-v2-button>
      }
    </div>
    <div class="bottom">
      @if (!contentEdit) {
        <p [innerHTML]="card?.text"></p>
      }
      @if (contentEdit) {
        <p
          #paragraph
          [contentEditable]="contentEdit"
          [textContent]="card?.text"
          (input)="card.text = paragraph.textContent"></p>
      }
      @if (!contentEdit && card?.button.name && card.button.url) {
        <coin-v2-button
          type="secondary"
          [text]="card.button?.name"
          (click)="onButtonClick(card.button)"></coin-v2-button>
      }
      @if (contentEdit && card?.button) {
        <coin-v2-button type="secondary">
          <span
            #spanElement
            class="secondary cursor-text"
            [contentEditable]="contentEdit"
            [textContent]="card?.button.name"
            (input)="card.button.name = spanElement.textContent"></span>
        </coin-v2-button>
      }

      @if (contentEdit) {
        <div class="flex-one"></div>
      }
      @if (contentEdit) {
        <coin-v2-text-input
          [label]="'cms.content-pages.button-link' | translate"
          [placeholder]="'https://...'"
          [(ngModel)]="card.button.url" />
      }
    </div>
  </div>
}
